import { ReactNode, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

type IProps = {
  isOpen: boolean;
  title?: string;
  btnTxt: string;
  closeBtn?: boolean;
  styles?: string;
  handleClose(): void;
  children: ReactNode;
};

export default function DefaultModal({
  isOpen,
  title,
  btnTxt,
  styles = "",
  closeBtn = true,
  handleClose,
  children,
}: IProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = "hidden";
    }
    return () => {
      window.document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    isOpen && (
      <section>
        {createPortal(
          <section className={"modal-layout"}>
            <div ref={modalRef} className={"modal" + " " + styles}>
              <div className="w-full between-center">
                <h3 className="w-full">{title}</h3>
                {closeBtn && (
                  <button
                    className="btn-close"
                    onClick={() => {
                      handleClose();
                    }}
                  />
                )}
              </div>
              {children}
            </div>
          </section>,
          document.body
        )}
      </section>
    )
  );
}
